<template>
  <div class="page-home">
    <search-panel @submit="submit" />
    <div class="search-filters-v2">
      <div class="search-filters-v2__tabs">
        <div class="tabs">
          <ul class="tabs__list">
            <li
              class="tabs__item"
              :class="{
                'is-active': activeTab === 'property',
              }"
            >
              <a
                class="tabs__link"
                :class="{
                  'is-active': activeTab === 'property',
                }"
                href="#"
                @click.prevent="activeTab = 'property'"
              >
                <span class="tabs__link-text">Property</span>
                <span class="tabs__link-icon">
                  <img
                    :src="require('@/assets/icons/icon-arrow-down.svg')"
                    alt=""
                  >
                </span>
              </a>
            </li>
            <li
              class="tabs__item"
              :class="{
                'is-active': activeTab === 'rates',
              }"
            >
              <a
                class="tabs__link"
                :class="{
                  'is-active': activeTab === 'rates',
                }"
                href="#"
                @click.prevent="activeTab = 'rates'"
              >
                <span class="tabs__link-text">Rates</span>
                <span class="tabs__link-icon">
                  <img
                    :src="require('@/assets/icons/icon-arrow-down.svg')"
                    alt=""
                  >
                </span>
              </a>
            </li>
            <li
              class="tabs__item"
              :class="{
                'is-active': activeTab === 'room',
              }"
            >
              <a
                class="tabs__link"
                :class="{
                  'is-active': activeTab === 'room',
                }"
                href="#"
                @click.prevent="activeTab = 'room'"
              >
                <span class="tabs__link-text">Room</span>
                <span class="tabs__link-icon">
                  <img
                    :src="require('@/assets/icons/icon-arrow-down.svg')"
                    alt=""
                  >
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="search-filters-v2__filters">
        <div v-if="activeTab === 'property'">
          <div class="filters-grid">
            <filter-folding
              key="starRating"
              :filter="filters.starRating"
              type="checkbox"
              :title="'Star Rating'"
              :initial-state="false"
            />
            <filter-folding
              key="tripadvisorRating"
              type="checkbox"
              :filter="filters.tripadvisorRating"
              title="Ratings & Reviews"
              :initial-state="false"
            />
            <filter-folding
              key="propertyType"
              type="checkbox"
              :filter="filters.propertyType"
              title="Property Type"
              :initial-state="false"
            />
            <filter-folding
              key="hotelChain"
              type="checkbox"
              :filter="filters.hotelChain"
              title="Hotel Chain"
              :initial-state="false"
            />
            <filter-folding
              key="amenities2"
              type="checkbox"
              :filter="filters.amenities2"
              title="Amenities"
              :initial-state="false"
            />
          </div>
        </div>
        <div v-if="activeTab === 'rates'">
          <div class="filters-grid">
            <filter-folding
              key="priceRange"
              type="slider"
              :filter="filters.priceRange"
              title="Price Range"
            />
            <filter-folding
              key="refundability"
              type="checkbox"
              :filter="filters.refundability"
              title="Refundability"
              :initial-state="false"
            />
            <filter-folding
              key="deals"
              type="checkbox"
              :filter="filters.deals"
              title="Deals"
              :initial-state="false"
            />
            <filter-folding
              key="payAtHotel"
              type="checkbox"
              :filter="filters.payAtHotel"
              title="Pay at hotel"
              :initial-state="false"
            />
          </div>
        </div>
        <div v-if="activeTab === 'room'">
          <div class="filters-grid">
            <filter-folding
              key="roomSize"
              type="slider"
              :filter="filters.roomSize"
              title="Room Size"
            />
            <filter-folding
              key="balcony"
              type="checkbox"
              :filter="filters.balcony"
              title="Balcony"
              :initial-state="false"
            />
            <filter-folding
              key="view"
              type="checkbox"
              :filter="filters.view"
              title="View"
              :initial-state="false"
            />
            <filter-folding
              key="roomClass"
              type="checkbox"
              :filter="filters.roomClass"
              title="Room Class"
              :initial-state="false"
            />
            <filter-folding
              key="beds"
              type="select"
              :filter="filters.beds"
              title="Beds"
            >
              <template #after>
                <span style="text-transform: uppercase; font-size: 9px; line-height: 20px;">beds in room</span>
              </template>
            </filter-folding>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import * as filters from '@/helpers/filters';
import SearchPanel from '@/components/search/SearchPanel';
import FilterFolding from '@/components/tiny/FilterFolding';

export default {
  name: 'page-search-hotels',
  components: {
    FilterFolding,
    SearchPanel,
  },
  data() {
    return {
      isLoading: false,
      activeTab: 'property',
      cities: [],
      filters: {
        starRating: cloneDeep(filters.starRating),
        priceRange: cloneDeep(filters.priceRange),
        propertyType: cloneDeep(filters.propertyType),
        roomClass: cloneDeep(filters.roomClass),
        roomSize: cloneDeep(filters.roomSize),
        tripadvisorRating: cloneDeep(filters.tripadvisorRating),
        hotelChain: cloneDeep(filters.hotelChain),
        deals: cloneDeep(filters.deals),
        refundability: cloneDeep(filters.refundability),
        view: cloneDeep(filters.view),
        balcony: cloneDeep(filters.balcony),
        payAtHotel: cloneDeep(filters.payAtHotel),
        beds: cloneDeep(filters.beds),
        amenities2: cloneDeep(filters.amenities2),
      },
    };
  },
  computed: {
    ...mapState(['hotelFacilitiesList']),
    columnsQty() {
      let qty;
      switch (this.$screen.breakpoint) {
        case 'xss':
          qty = 1;
          break;
        case 'xs':
          qty = 2;
          break;
        case 'sm':
        case 'tablet':
        case 'laptop':
          qty = 3;
          break;
        case 'md':
        case 'lg':
          qty = 4;
          break;
      }
      return qty;
    },
  },
  async created() {
    const loader = this.$loading.show();
    this.isLoading = true;

    const [cities] = await Promise.all([
      this.getCities(),
      this.getHotelFacilitiesList(),
    ]);

    this.cities = cities;

    loader.hide();
    this.isLoading = false;
  },
  methods: {
    ...mapActions([
      'getHotelFacilitiesList',
      'getCities',
    ]),
    async submit(params) {
      const loader = this.$loading.show();
      const minWait = 300;
      const wait = Math.floor(Math.random() * Math.floor(7)) * 100;
      await new Promise(resolve => setTimeout(resolve, wait > 100 ? wait : minWait));
      loader.hide();

      if (params.hotel) {
        await this.$router.push({
          name: 'content',
          params: {
            id: params.hotel.id,
          },
        });
      } else {
        await this.$router.push({
          name: 'search-results',
          query: {
            type: params.type.id,
            city: params.city ? params.city.id : undefined,
          },
        });
      }
    },
    clearAmenity(id) {
      const index = this.filters.amenities.selected.findIndex(item => id === item.id);
      if (index === -1) return;
      this.filters.amenities.selected.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
.page-home {
  display: flex;
  flex-direction: column;
  height: 100%;

  .search-filters-v2 {
    flex-grow: 1;
  }
}

.search-filters-v2 {
  &__tabs {
    border-top: 2px solid rgba(#6e7c91, 0.07);
  }

  &__filters {
    background: #32325a;
  }
}
</style>
<style lang="scss" scoped>
.filters-grid {
  display: grid;
  grid-template-columns: 1fr;
  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media screen and (min-width: 1024px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  @media screen and (min-width: 1600px) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .box-folding {
    margin: -1px 0 0 -1px;
  }
}

.tabs {
  font-size: 15px;
  line-height: 20px;
  font-weight: bold;
  color: #6e7c91;

  &__list {
    display: flex;
  }

  &__item {
    border-right: 2px solid rgba(#6e7c91, 0.07);
  }

  &__link {
    text-decoration: none;
    color: currentColor;
    padding: 35px 42px 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 178px;

    &.is-active {
      background-color: #32325a;
      color: #fff;
    }
  }

  &__link-icon {
    font-size: 0;
    line-height: 0;
    width: 10px;
    margin-left: 15px;

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}
</style>
